import { NgModule } from '@angular/core';
import { DisableControlDirective } from './disable-control.directive';
@NgModule({
  declarations: [
    DisableControlDirective
  ],
})
export class DirectivesModule{}